import React from "react";
import AutomatedMessageTag from "venuescanner-js/react/components/Inbox/components/Chat/AutomatedMessage/AutomatedMessageTag";

const AutomatedMessageText = (props) => {
  const { tagTitle, tagClass, children } = props;

  return (
    <div>
      <AutomatedMessageTag title={tagTitle} classes={tagClass} />
      <div className="automated-message__item automated-message__item--text-only">
        <div className="automated-message__content">{children}</div>
      </div>
    </div>
  );
};

export default AutomatedMessageText;
